import { Route } from "@angular/router";
import { RedirectESignPageComponent } from "./components/redirect-esign-page/redirect-e-sign-page.component";

export function getRedirectsRoutes(): Route[] {
  return [
    {
      path: 'guest/redirect/esign/:id',
      component: RedirectESignPageComponent
    },
  ];
}
